// Coordinate-system conversion for client-viewer click events.
//
// Meshes ship in a projected CRS (per the site YAML's `mesh_crs`).
// Click events resolve to mesh-local Z-up coordinates, then add the
// utm_center offset to recover the projected coordinate. To show
// decimal lat/lon to engineers, we proj4 from the projected CRS to
// WGS84.
//
// Until the bundle producer ships the CRS in client_meta.json, the
// viewer assumes EPSG:3400 (NAD83(CSRS) / Alberta 3-TM ref. merid.
// 114°W) — the standard for PFD's Alberta deployments. When the
// CRS lands in the bundle metadata, swap to that.

import proj4 from "proj4";

// EPSG:3400 — NAD83(CSRS) / Alberta 3-TM ref. meridian 114°W.
proj4.defs(
  "EPSG:3400",
  "+proj=tmerc +lat_0=0 +lon_0=-114 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs"
);

const DEFAULT_SOURCE_CRS = "EPSG:3400";

export function projectedToLatLon(
  projected: [number, number, number],
  sourceCrs: string = DEFAULT_SOURCE_CRS
): [number, number] | null {
  try {
    const [x, y] = projected;
    const result = proj4(sourceCrs, "WGS84", [x, y]) as [number, number];
    const [lon, lat] = result;
    if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
    return [lat, lon];
  } catch (err) {
    console.warn("CRS conversion failed:", err);
    return null;
  }
}
